import { useEffect, useRef } from 'react';
import TableFilter from './table-filter';
import TableSorter from './table-sorter';
import { TableHeadTypes } from './types';

import './table.css';

export default function TableHeadItem({
  withScroll,
  tableHeadCellClassName,
  filtersComponent,
  sort,
  onSort,
  filters,
  column,
  elementIsVisibleInViewport,
  index,
  morePadding,
  fullWidthTable,
}: TableHeadTypes) {
  const itemRef = useRef<any | null>(null);

  useEffect(() => {
    if (itemRef && itemRef.current) {
      elementIsVisibleInViewport(itemRef.current, index, true);
    }
  }, [itemRef, column]);

  return (
    <th
      className={`${withScroll ? 'with-scroll' : ''} ${
        morePadding ? 'head-more-padding' : ''
      }`}
      ref={itemRef}
    >
      <div
        className={`table-head-cell ${tableHeadCellClassName} ${
          fullWidthTable ? 'nowrap' : ''
        }`}
      >
        {filtersComponent && filtersComponent.element[column.name] && (
          <TableFilter
            column={column}
            isActive={
              Array?.isArray(filters[column.name]?.value)
                ? Boolean(filters[column.name]?.value?.length)
                : Boolean(filters[column.name])
            }
            filters={filters}
            withOverflow={filtersComponent.withOverflow[column.name]}
            withDateOverflow={filtersComponent.withDateOverflow[column.name]}
          >
            {filtersComponent.element[column.name]}
          </TableFilter>
        )}
        <TableSorter
          column={column}
          sort={sort}
          onChange={() => onSort(column.name)}
          withoutSort={!column.sortable}
        />
      </div>
    </th>
  );
}
